import { Component, inject } from '@angular/core';
import { UserService } from '@trp/community/user/feature-user';
import {
  NOTIFICATIONS as ACCESS_NOTIFICATIONS,
  AccessRequestApprovedNotificationContent,
  AccessRequestCreatedNotificationContent,
  AccessRequestRejectedNotificationContent,
} from '@trp/community/access/interfaces';
import {
  NOTIFICATIONS as COMMUNITY_UPDATE_NOTIFICATIONS,
  SubmissionAcceptedNotificationContent,
  SubmissionRejectedNotificationContent,
  SubmissionSubmittedNotificationContent,
} from '@trp/community/community-update/interfaces';
import { NotificationFacade } from '@trp/community/notification/client-data-access';
import {
  PROGRAM_VERIFICATION_NOTIFICATIONS,
  ProgramVerificationProgramVerifiedContent,
  ProgramVerificationVerificationExpiredContent,
} from '@trp/community/program-verification/interfaces';
import {
  EmailVerifiedNotificationContent,
  NOTIFICATIONS as USER_NOTIFICATIONS,
  VerifyEmailNotificationContent,
} from '@trp/community/user/interfaces';
@Component({
  selector: 'community-banner-container',
  templateUrl: './banner-container.component.html',
  styleUrls: ['./banner-container.component.scss'],
})
export class BannerContainerComponent {
  private readonly userService = inject(UserService);
  contactHref$ = this.userService.contactHref$;

  approvedAggregate$ =
    this.notificationFacade.getDismissableAggregate$<AccessRequestApprovedNotificationContent>(
      ACCESS_NOTIFICATIONS.accessRequestApproved
    );

  rejectedAggregate$ =
    this.notificationFacade.getDismissableAggregate$<AccessRequestRejectedNotificationContent>(
      ACCESS_NOTIFICATIONS.accessRequestRejected
    );

  createdAggregate$ =
    this.notificationFacade.getDismissableAggregate$<AccessRequestCreatedNotificationContent>(
      ACCESS_NOTIFICATIONS.accessRequestCreated
    );

  communityUpdates = {
    // One notification is created per updated section, so the banners count
    // distinct communities instead of notifications.
    approvedAggregate$:
      this.notificationFacade.getDismissableAggregate$<SubmissionAcceptedNotificationContent>(
        COMMUNITY_UPDATE_NOTIFICATIONS.submissionAccepted,
        ({ communityId }) => communityId
      ),

    rejectedAggregate$:
      this.notificationFacade.getDismissableAggregate$<SubmissionRejectedNotificationContent>(
        COMMUNITY_UPDATE_NOTIFICATIONS.submissionRejected,
        ({ communityId }) => communityId
      ),

    submittedAggregate$:
      this.notificationFacade.getDismissableAggregate$<SubmissionSubmittedNotificationContent>(
        COMMUNITY_UPDATE_NOTIFICATIONS.submissionSubmitted,
        ({ communityId }) => communityId
      ),
  };

  programVerifications = {
    verifiedAggregates$:
      this.notificationFacade.getDismissableAggregate$<ProgramVerificationProgramVerifiedContent>(
        PROGRAM_VERIFICATION_NOTIFICATIONS.programVerified
      ),
    verificationExpiredAggregates$:
      this.notificationFacade.getDismissableAggregate$<ProgramVerificationVerificationExpiredContent>(
        PROGRAM_VERIFICATION_NOTIFICATIONS.verificationExpired
      ),
  };

  verifyEmailNotification$ =
    this.notificationFacade.getOneNotificationOfType$<VerifyEmailNotificationContent>(
      USER_NOTIFICATIONS.verifyEmail
    );

  emailVerifiedNotification$ =
    this.notificationFacade.getOneNotificationOfType$<EmailVerifiedNotificationContent>(
      USER_NOTIFICATIONS.emailVerified
    );

  simpleNotification$ = this.notificationFacade.simpleNotification$;

  constructor(public notificationFacade: NotificationFacade) {}
}
